export const addItemRecipe =
  <T>(item: T) =>
  (draft: T[]): T[] => {
    draft?.push(item);
    return draft;
  };
